import { t } from 'i18next';

export const getLocationSearchOption = () => ({
	type: 'location',
	label: t('Location'),
	inputs: {}
});

export const lowAltitudeFeet = 0;

export const midAltitudeFeet = 1000;

export const highAltitudeFeet = 5000;

export const droneTagProviderName = 'dronetag_public';
export const hiddenLevelProviderName = 'hidden_level';
export const airMeshProviderName = 'airmesh_sdk';
